import { Component, Input, TemplateRef } from '@angular/core';

import { directionsEnum } from '../../enums/directions.enum';

@Component({
    selector: 'agpr-popover-window',
    templateUrl: 'popover.component.html',
    styleUrls: ['popover.component.scss'],
    standalone: false
})
export class PopoverComponent {

    @Input() contentTemplate: TemplateRef<any> = null;
    @Input() position: directionsEnum = null;
    @Input() styleClass: string;

    directionsEnum = directionsEnum;

}
